module.exports = __webpack_public_path__ + "static/media/raspberry_burned.aed1ae7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/raspberry_burned.png
// module id = 22
// module chunks = 0